var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "HKLModal",
    {
      ref: "modal",
      attrs: {
        closable: true,
        afterClose: _vm.$attrs.afterClose,
        hasOkBtn: false,
        hasCancelBtn: false,
        width: "900px",
        dialogStyle: { "padding-top": "40px", "margin-top": "0%", top: "0px" },
      },
      scopedSlots: _vm._u(
        [
          _vm.canEdit
            ? {
                key: "footer",
                fn: function () {
                  return [
                    _c("HKLButton", {
                      staticClass: "btn",
                      attrs: { color: "darkblue", action: "save" },
                      on: { click: _vm.onSave },
                    }),
                    _vm._v(" "),
                    _c("HKLButton", {
                      staticClass: "btn",
                      attrs: { color: "orange", action: "send" },
                      on: { click: _vm.onSend },
                    }),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _c(
        "HKLForm",
        { ref: "formRef", attrs: { canEdit: _vm.canEdit } },
        [
          _c("HKLFormItem", { attrs: { label: _vm.$t("subject") } }, [
            _vm._v("\n      " + _vm._s(_vm.subject) + "\n    "),
          ]),
          _vm._v(" "),
          _c(
            "HKLFormItem",
            {
              staticClass: "to text-input",
              attrs: { label: _vm.$t("to"), required: true },
            },
            [
              _c("HKLInputEmails", {
                directives: [
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  { name: "autosize", rawName: "v-autosize" },
                ],
                attrs: { checkerOptions: { required: true } },
                model: {
                  value: _vm.formData.to,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "to", $$v)
                  },
                  expression: "formData.to",
                },
              }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.formData.to || _vm.$t("emptyValue")) +
                  "\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "HKLFormItem",
            { staticClass: "cc text-input", attrs: { label: _vm.$t("cc") } },
            [
              _c("HKLInputEmails", {
                directives: [
                  { name: "hkldinput", rawName: "v-hkldinput" },
                  { name: "autosize", rawName: "v-autosize" },
                ],
                model: {
                  value: _vm.formData.cc,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "cc", $$v)
                  },
                  expression: "formData.cc",
                },
              }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.formData.cc || _vm.$t("emptyValue")) +
                  "\n    "
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isTenant
            ? _c(
                "HKLFormItem",
                {
                  staticClass: "bcc text-input",
                  attrs: { label: _vm.$t("bcc") },
                },
                [
                  _c("HKLInputEmails", {
                    directives: [
                      { name: "hkldinput", rawName: "v-hkldinput" },
                      { name: "autosize", rawName: "v-autosize" },
                    ],
                    model: {
                      value: _vm.formData.bcc,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "bcc", $$v)
                      },
                      expression: "formData.bcc",
                    },
                  }),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.formData.bcc || _vm.$t("emptyValue")) +
                      "\n    "
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("img", {
              directives: [
                {
                  name: "region-img-src",
                  rawName: "v-region-img-src",
                  value: "email-logo-hkland.png",
                  expression: "'email-logo-hkland.png'",
                },
              ],
              staticClass: "hkland-logo",
              attrs: { alt: "Hongkong Land" },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("tenantProjects.inspection.dearAll")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "HKLFormItem",
            [
              _c("DescriptionTinymceEditor", {
                directives: [
                  {
                    name: "fusioninputcheck",
                    rawName: "v-fusioninputcheck",
                    value: {
                      type: "string",
                      required: true,
                    },
                    expression:
                      "{\n          type: 'string',\n          required: true,\n        }",
                  },
                ],
                ref: "descriptionRef",
                model: {
                  value: _vm.formData.content,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "content", $$v)
                  },
                  expression: "formData.content",
                },
              }),
              _vm._v(" "),
              _c("div", {
                domProps: { innerHTML: _vm._s(_vm.formData.content) },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "HKLFormItem",
            { attrs: { label: _vm.$t("attachments") } },
            [
              _vm.validAttachments.length
                ? _c(
                    "ul",
                    { staticClass: "attachments" },
                    _vm._l(_vm.validAttachments, function (item, index) {
                      return _c("li", { key: index }, [
                        _vm._v(
                          "\n          " + _vm._s(item.filename) + "\n        "
                        ),
                      ])
                    }),
                    0
                  )
                : [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("emptyValue")) + "\n      "
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }